import { render, staticRenderFns } from "./FugaLabels.vue?vue&type=template&id=5573158a&"
import script from "./FugaLabels.vue?vue&type=script&lang=js&"
export * from "./FugaLabels.vue?vue&type=script&lang=js&"
import style0 from "./FugaLabels.vue?vue&type=style&index=0&id=5573158a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports